<template>
  <div >
    <vs-popup
      :title="'Delete this '+deleteWhat+'?'"
      class="custom-popup delete-pop-up"
      :active.sync="isPopupActive"
      style="color: rgb(255, 255, 255)"
      background-color="rgba(255,255,255,.6)"
    >
      <!-- <div class="popup-header flex items-center">
        <vs-icon
          icon="error_outline"
          size="3rem"
          class="mr-3"
        ></vs-icon>
        <h3 class="font-bold">Delete this {{ deleteWhat }}?</h3>
      </div> -->
      <p class="text-gray-font" >
        Are you sure you want to permanently delete this {{ deleteWhat }}? You
        can’t undo this action.
      </p>
      <p class="mt-5 text-gray-font">
        {{ additionalMsg }}
      </p>
      <br />
      <div class="error-message-container" v-if="found">
        <div >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.2898 3.85996L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3437 1.64127 19.6871 1.8142 19.9905C1.98714 20.2939 2.2365 20.5467 2.53748 20.7238C2.83847 20.9009 3.18058 20.9961 3.52978 21H20.4698C20.819 20.9961 21.1611 20.9009 21.4621 20.7238C21.7631 20.5467 22.0124 20.2939 22.1854 19.9905C22.3583 19.6871 22.4488 19.3437 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.85996C13.5315 3.56607 13.2805 3.32308 12.981 3.15444C12.6814 2.98581 12.3435 2.89722 11.9998 2.89722C11.656 2.89722 11.3181 2.98581 11.0186 3.15444C10.7191 3.32308 10.468 3.56607 10.2898 3.85996V3.85996Z" stroke="#EB5757" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 9V13" stroke="#EB5757" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M12 17H12.01" stroke="#EB5757" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        </div>

        <div class="pl-4">
          <span class="font-medium text-lg">WARNING</span>
          <br />
          <p class="text-base font-light text-text-blue">
            {{ warningContent }}
          </p>
        </div>
      </div>

      <div class="actions mt-5 text-right w-full">
        <vs-button
        size="large"
          class=" btn-delete mr-8"
          @click="handleClick('delete')"
          v-round
          >{{ buttonText }}</vs-button
        >
        <a class="mid-blue" v-round @click="handleClick('cancel')"
          ><u>Cancel</u></a
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { AlertCircleIcon } from "vue-feather-icons";
export default {
  name: "DeletePopup",
  props: {
    popupActive: { required: true, type: Boolean },
    warningContent: { required: false, type: String },
    additionalMsg: { required: false, type: String},
    deleteWhat: { required: false, type: String },
    buttonText: { required: false, type: String },
    found: { required: false, type: Boolean },
  },
  components: { AlertCircleIcon },
  computed: {
    isPopupActive: {
      // getter
      get: function () {
        return this.popupActive;
      },
      // setter
      set: function (newValue) {
        
        this.handleClick("close");
      },
    },
  },
  methods: {
    handleClick(value) {
      this.$emit("handleDeleteClick", value);
      return;
    },
  },
};
</script>